import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { H2 } from '../../../styles/generic';

const ModalHeader = ({ children }: PropsWithChildren) => (
  <Header aria-level={1}>{children}</Header>
);

export default ModalHeader;

const Header = styled(H2)`
  margin: 0 0 16px 0;
  max-width: 90%;
`;
